import React, { FC, useState } from 'react';
import { ForgeButton, ForgeIcon, ForgeTooltip, ForgeDialog } from '@tylertech/forge-react';
import { I18n } from 'common/i18n';
import { useDispatch } from 'react-redux';
import { ForgeScaffold } from '@tylertech/forge-react';
import { ForgeToolbar } from '@tylertech/forge-react';
const scope = 'shared.components.asset_action_bar.reset_to_default';

const ResetToDefaultButton: FC = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const dispatch = useDispatch();
  const handleOpenDialog = () => setIsDialogOpen(true);
  const handleCloseDialog = () => setIsDialogOpen(false);
  const handleReset = () => {
    dispatch({ type: 'TRIGGER_PERSONALIZED_STORY_RESET' });
  };

  const handleConfirm = () => {
    handleReset();
    setTimeout(handleCloseDialog, 0);
  };

  return (
    <>
      <ForgeButton
        onClick={handleOpenDialog}
        data-testid="reset-to-default-button"
        aria-label={I18n.t('button', { scope: scope })}
        id="reset-to-default-button"
      >
        <ForgeIcon name="restore" aria-hidden="false" external external-type="extended" />
        {I18n.t('button', { scope: scope })}
      </ForgeButton>
      <ForgeTooltip placement={'bottom'} anchor="reset-to-default-button">
        {I18n.t('tooltip', { scope: scope })}
      </ForgeTooltip>
      <ForgeDialog
        className="reset-to-default-dialog"
        open={isDialogOpen}
        on-forge-dialog-close={handleCloseDialog}
        data-testid="reset-dialog"
        aria-labelledby="reset-dialog-title"
        aria-describedby="reset-dialog-message"
      >
        <ForgeScaffold>
          <ForgeToolbar slot="header" no-divider>
            <h2
              className="forge-typography--heading4"
              data-testid="reset-dialog-title"
              id="reset-dialog-title"
            >
              {I18n.t('dialog_header', { scope: scope })}
            </h2>
          </ForgeToolbar>
          <section slot="body">
            <p
              id="reset-dialog-message"
              className="forge-typography--body1"
              data-testid="reset-dialog-message"
            >
              {I18n.t('dialog_message', { scope: scope })}
            </p>
          </section>
          <ForgeToolbar slot="footer" no-divider>
            <ForgeButton
              slot="end"
              onClick={handleCloseDialog}
              variant="outlined"
              data-testid="reset-dialog-cancel"
            >
              {I18n.t('dialog_cancel_button', { scope: scope })}
            </ForgeButton>
            <ForgeButton
              slot="end"
              onClick={handleConfirm}
              variant="raised"
              data-testid="reset-dialog-confirm"
              forge-dialog-focus="true"
            >
              {I18n.t('dialog_reset_button', { scope: scope })}
            </ForgeButton>
          </ForgeToolbar>
        </ForgeScaffold>
      </ForgeDialog>
    </>
  );
};

export default ResetToDefaultButton;
